import axios from 'axios'
import {errorHelper} from '../helper.js'
import { AUTH_URL } from '../../../vars'

/**
 * @namespace ResetPassword
 */
export default {
    state: {
        
    },
    mutations: {
        
    },
    actions: {
        /**
         * 
         * @param {Object} ctx 
         * @param {Object} data Данные для смены пароля
         * @returns {Object} Данные резьтата смены пароля
         * @throws {Object} Ошибка запроса данных 
         * 
         * @memberof ResetPassword
         */
       async RESET_PASSWORD_LINK(ctx, data) {
           try {
            console.log('RESET_PASSWORD_LINK', data)
                const res = await axios.post(`${AUTH_URL}send-reset-password-link/`, data,  {
                    validateStatus: function (status) {
                      return status < 500; // Разрешить, если код состояния меньше 500
                    }
                  });
                  return res
            } catch(e) {
                errorHelper(e)
                // this.$messageHelper('', 'error', 6000, e)
                throw e
            }
       },
       /**
         * 
         * @param {Object} ctx 
         * @param {Object} data Данные для смены пароля
         * @returns {Object} Данные резьтата смены пароля
         * @throws {Object} Ошибка запроса данных 
         * 
         * @memberof ResetPassword
         */
       async RESET_PASSWORD(ctx, data) {
            try {
                const res = await axios.post(`${AUTH_URL}reset-password/`, data,  {
                    validateStatus: function (status) {
                      return status < 500; // Разрешить, если код состояния меньше 500
                    }
                  })
                return res
            } catch(e) {
                errorHelper(e)
                // messageHelper('', 'error', 6000, e)
                throw e
            }
       }
    },
    getters: {
        
    }
}